import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getPerformance } from "firebase/performance";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAcGbIoBCaSCUZhoqcEf4LXHlJZCu7k93I",
  projectId: "connect-social-project",
  storageBucket: "connect-social-project.appspot.com",
  appId: "1:376521021326:web:da937148b2599ed221b6df",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, "cs");
export const storage = getStorage(app);
const analytics1 = getAnalytics(app);
export const db = getFirestore(app);
const firebaseConfig2 = {
  apiKey: "AIzaSyArO6n1EnvQ0hAAfXPFJVn0PcbZHbpUjY4",

  authDomain: "arthereum-wallet.firebaseapp.com",

  projectId: "arthereum-wallet",

  storageBucket: "arthereum-wallet.firebasestorage.app",

  messagingSenderId: "375858750091",

  appId: "1:375858750091:web:a741ebed7ea2a80b696a8e",
  measurementId: "G-F6WE4C3PE1",
};

// Initialize Firebase

const app2 = initializeApp(firebaseConfig2);

const analytics = getAnalytics(app2);
const perf = getPerformance(app2);
